<script>
	import {game, send_request, fetch_data, view} from "../client.svelte.js";
	import {docs, whatsnew} from "../core.js"
	import { marked } from 'marked';
	import {onMount} from "svelte";

	let dialog    // HTMLDialogElement, required: .show()
	let { mode } = $props()			// mode = whatnew | demo | docs
	let currentIndex = $state((mode === 'demo') ? 0 : whatsnew.length - 1)
	let current = $derived(
			(mode === 'whatsnew') ? whatsnew[currentIndex] :
			(mode === 'demo') ? game.demo[currentIndex] : view.explanation )
	let relevants = $derived(
		(mode === 'whatsnew') ? whatsnew :
		(mode === 'demo') ? game.demo :
			docs.filter(entry => entry.section === current.section))

		let execLabel = $derived(
			(current?.command === 'TERMINATE') ? "BEENDEN" :
			(current?.command in commands) ? commands[current.command] :
			(Object.keys(ROUTES).includes(current?.command)) ? ROUTES[current.command] :
			(Object.keys(CHANNELS).includes(current?.command)) ? CHANNELS[current.command] : null
		)
		let executed = $state(false)


    onMount( () => {
		    if (['whatsnew', 'help'].includes(mode))
						dialog.show()
		    else {
						currentIndex = Number(sessionStorage.getItem('demoStep')) ?? 0
						update_hint()
		   		 	dialog.showModal()
		    }
	      console.log(`  – open item dialog in mode '${mode}' for `, $state.snapshot(current)) })

    function closing_dialog() {
				if (mode === 'demo') {
						sessionStorage.removeItem('demoStep')
						game.terminate()
						user.logout()
				}
				view.close_dialog()  }

		$inspect(`INFORM - show current information on ${view.help}`, current)


	function update_hint() {
		if (mode === 'demo')
			sessionStorage.setItem('demoStep', currentIndex)
	}
	function prev_hint() {
		const index = relevants.indexOf(current)
		if (index > 0) {
			view.explanation = relevants[index - 1]
				currentIndex -= 1
			update_hint()
		}
	}

	function next_hint(e) {
			const index = relevants.indexOf(current)
			if (index < relevants.length - 1) {
					view.explanation = relevants[index + 1]
					currentIndex += 1
					update_hint()
			}
			if (relevants.indexOf(current) === relevants.length - 1)
				sessionStorage.setItem('demo', null)
			executed = false
	}

		function excute_command(e) {
				console.log(`  - Execute command ${current.command} with params`, current.params)
				// parse parameters of command
				let paramsList = []
				if (current.params) {
						const params = JSON.parse(current.params)
						paramsList = (params instanceof Array) ? params : [params]
				}
				// parse command
				if (current.command in commands)
						send_request('control', Object.assign({command: current.command}, JSON.parse(current.params)))
				else if (Object.keys(ROUTES).includes(current.command))
					for (let params of paramsList)
						fetch_data(`/${current.command.toLowerCase()}`, params)
				else if (Object.keys(CHANNELS).includes(current.command))
					for (let params of paramsList)
						send_request(current.command.toLowerCase(), params)
				game.demo[currentIndex].executed = executed = true
		}
	const ROUTES = {SET: "MODUS ÄNDERN", CLOSE: "SZENE SCHLIESSEN", ASSIGN: "CHARAKTER ZUWEISEN", STATS: "STATISTIK ZEIGEN", LOAD: "SZENE LADEN"}
	const CHANNELS = {scene: "", ORDER: "AUSFÜHREN", UPDATE: "ÄNDERN", ADJUST: "", preview: "", PREPARE: "VORBEREITEN", PROCEED: "ABLAUF STARTEN", CENTER: "MARKIERUNG ZEIGEN"}
	const commands = {SHOW: "Bild anzeigen", MODE: "Modus umschalten", SWITCH: "Szene starten", TERMINATE: "Demo beenden"}
</script>


<!-------------------------------- HTML -------------------------------------->

<dialog bind:this={dialog} class={mode} onclose={closing_dialog}>
	<h2>{current.title}</h2>
	<div class="close fa icon-square-xmark" onclick={() => dialog.close()}></div>
	<hr />

	<div class="doc-text">
		{@html marked(current.text ?? "")}
	</div>
	<hr />

	<button onclick={prev_hint}>Zurück</button>
	{#if current.command}
		<button onclick={excute_command}>{execLabel}</button>
	{/if}
	{#if !current.command || current.executed || executed}
		<button autofocus onclick={next_hint}>Weiter</button>
	{/if}
	<button class=terminate onclick={() => dialog.close()}>
		{#if mode === 'whatsnew'}
			SCHLIESSEN
		{:else}
			BEENDEN
		{/if}
	</button>
</dialog>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	dialog
		max-width: 32em
		right: 0
		left: unset
		bottom: 0
		height: 98%
		margin: 8px
		padding: 12px
		color-scheme: light

		*
			color-scheme: light

	dialog.demo
		top: unset

	dialog::backdrop
		background: rgba(0, 0, 0, 0.3)

	dialog > div
		padding: 1em

	dialog[open]
		animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)

	@keyframes zoom
		from
			transform: scale(0.95)
		to
			transform: scale(1)

	dialog[open]::backdrop
		animation: fade 0.2s ease-out

	@keyframes fade
		from
			opacity: 0
		to
			opacity: 1

	h2
		margin: 8px

	button
		display: inline-block

	.close
		position: absolute
		right: 0
		top: -8px
		float: right
		font-size: larger
		color: lightgray

	.close:hover
		color: lightcoral

	.terminate
		float: right

	.doc-text
		height: 85%
		overflow-y: auto
		scrollbar-width: none
		&::-webkit-scrollbar
			display: none

</style>
